// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"264":"4a40a8dd","594":"4a40a8dd","654":"4a40a8dd","771":"77a36151"}[chunkId] + ".css";
};